import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerRed from '../../assets/Images/hacker.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const Penetration = () => {
useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas red'}><br /> Penetration Testing</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                             Our Red Team Conduct a series of technical
assessments on your organization’s security controls to discover the
weakness on network infrastructure, operating systems, databases, and
software application. Our team will use various tools and techniques to
find unintended services made publicly available by your network and we
also apply real-world attackers approaches to highlight unknown
vulnerabilities on the given scope.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'danger'} />
                    <img src={hackerRed} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardRed mt-5'} Title={"Web Applications "} text={'We have a variety of advanced penetration testing methodologies that we apply against your web application to ensure you the best results, also we focus on the OWASP top 10 and and CWE top 25 vulnerabilities for web applications.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Mobile Applications "} text={'We were inspired by the OWASP standards and customized it in order to achieve compatibility \n' +
                    'with the quality of service required. \n' +
                    'Our team’s comprehensive method covers the classes of vulnerabilities in the\n' +
                    ' Mobile Application Security Project (OWASP) Top 10, including, but not \n' +
                    'limited.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"API "} text={'We involve all processes of checking for vulnerabilities and building strong endpoints in your APIs.\n' +
                    '\n' +
                    'One of the most common web application threats is API abuse, which can cause hindrances to the smooth running of any digital industry. Issues like data leakage, unauthorized access, and parameter tampering can arise with any deployed APIs if they don’t undergo comprehensive security testing.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Infrastructure "} text={'Uncovers vulnerabilities residing in your IT systems and provides a tailored approach to each environment.\n' +
                    '\n' +
                    'Uncover any unsecured configurations, perimeters and access controls in your AD infrastructure.'}/>

                <Square className={'mx-4 cardRed mt-5'} Title={"Cloud "} text={'We empower organizations to bolster the security of their cloud environments, prevent avoidable breaches to their systems, and remain compliant with their industry’s regulations.\n' +
                    '\n' +
                    'we do this by helping to identify vulnerabilities, risks, and gaps in a security program.'} />
                <Square className={'mx-4 cardRed mt-5'} Title={"Wireless "} text={'Wireless security guards against unauthorized and malicious access attempts to a network.'} />
            </div>
            <Title className={'mt-6'} header={"the"} body={"Process"} />
            <div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>
                <Rectangle className={'mt-4 cardRed'} Title={'Plan & Reconnaissance'} text={''} />
                <Rectangle className={'mt-4 cardRed'} Title={'Scheduling'} text={''} />
                <Rectangle className={'mt-4 cardRed'} Title={'Testing & Identify Weaknesses'} text={''} />
                <Rectangle className={'mt-4 cardRed'} Title={'Assessment Reporting & Delivering'} text={''} />
                <Rectangle className={'mt-4 cardRed'} Title={' Optional Remediation Retest'} text={''} />
            </div>


            <Footer />
        </>
    );

}

export default Penetration;